<div class="flex  justify-center">
  <nz-spin [nzSpinning]="this.loading">
    <div class="flex flex-wrap justify-center gap-5">
      <div class="flex flex-col text-center">
        <h3>{{ 'chargebee.subscription.title' | transloco }}</h3>
        <span class="text-[#6B7280]">{{ 'chargebee.subscription.subtitle' | transloco }}</span>
      </div>
    </div>
    <div class="mt-6">
      <nz-button-group class="flex flex-row  rounded-lg justify-center m-3">
        <button
          *ngFor="let plan of this.listOfPlans"
          nz-button
          (click)="this.onSelectedPlan(plan)"
          [ngClass]="
        this.selectedCycle === plan.item_price.period_unit
          ? 'px-4 py-2 rounded-full bg-white text-gray-900 shadow-lg font-medium border-2  border-[#6911d8]'
          : 'px-4 py-2 rounded-full bg-gray-100 text-gray-500'
      "
        >
          <!-- Show discount only for Year -->
          <ng-container *ngIf="plan.item_price.period_unit === this.SETTINGS.PERIOD_UNIT.YEAR; else normal">
            {{ 'chargebee.subscription.billingCycles.yearly' | transloco }} <span class="text-green-500 ml-1">({{ 'chargebee.subscription.billingCycles.yearlyDiscount' | transloco }})</span>
          </ng-container>
          <ng-template #normal>
            {{ 'chargebee.subscription.billingCycles.monthly' | transloco }}
          </ng-template>
        </button>
      </nz-button-group>
      <div class="my-4 flex justify-center">
        <a class="text-primary hover:opacity-80" style="text-decoration: underline !important;" href="https://travsta.purple.lk/pricing" target="_blank">
          {{ 'chargebee.subscription.pricingLink' | transloco }}
        </a>
      </div>
      <button
        nz-button
        class="mr-2 mb-5 w-full"
        [disabled]="this.selectedPlan === null"
        (click)="isUpgrade ? this.upgradeToYearly() : this.createdHostedPage()"
        nzType="primary">
        {{ 'chargebee.subscription.continueWith' | transloco }}
        {{this.selectedCycle === this.SETTINGS.PERIOD_UNIT.MONTH ?
        ('chargebee.subscription.billingCycles.monthly' | transloco) : ('chargebee.subscription.billingCycles.yearly' | transloco)}}
      </button>
      <div class="my-3 flex justify-center">
        <p>
          {{ 'chargebee.subscription.questions' | transloco }}
          <a href="mailto:support@travsta.com" class="text-primary hover:underline">
            support@travsta.com
          </a>
        </p>
      </div>
    </div>
  </nz-spin>
</div>
